import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function DeleteUser({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Delete User'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

